export default __webpack_public_path__ + "static/media/craonmini.4e711ece.jpg";